export default __webpack_public_path__ + "static/media/empty-profile.3edc5bc9.jpg";